module.exports = "<div class=\"container\">\r\n  <h2>Analytics Pack - visualize survey results</h2>\r\n  <survey-analytics></survey-analytics>\r\n</div>\r\n"